import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'VitaCore',
  brandName: 'VitaCore',
  description: 'Sistema de agendamento para médicos',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Clínica médica moderna',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Médico consultando paciente',
  },
  testimonials: [
    {
      name: 'Dr.ª Sofia Almeida',
      role: 'Cardiologista',
      text: 'O VitaCore simplificou a gestão da minha agenda e permitiu-me focar totalmente nos meus pacientes.',
      image: testimonial1,
    },
    {
      name: 'Ricardo Jorge',
      role: 'Paciente',
      text: 'Marcar consulta através do sistema foi muito fácil e rápido. A confirmação e os lembretes são excelentes.',
      image: testimonial2,
    },
    {
      name: 'Centro Médico Viver',
      role: 'Administração',
      text: 'A implementação do VitaCore reduziu o trabalho administrativo e melhorou a experiência dos nossos pacientes.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'médico',
    professionals: 'médicos',
    business: 'clínica',
    businesses: 'clínicas',
    service: 'consulta',
    services: 'consultas',
    client: 'paciente',
    clients: 'pacientes',
    appointment: 'consulta',
    appointments: 'consultas',
  },
  homepage: {
    hero: {
      badge: 'Solução Médica',
      title: 'Simplifique sua agenda médica com VitaCore',
      description: 'Otimize o tempo de consulta e ofereça o melhor cuidado aos seus pacientes com o VitaCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Sem cartão de crédito', 'Configuração em 5 minutos'],
    },
    statistics: [
      { value: '180+', label: 'Clínicas' },
      { value: '28k+', label: 'Consultas' },
      { value: '98%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Interrupções Durante Consultas',
        description: 'Atender telefone durante o atendimento compromete a qualidade do cuidado e gera desconforto aos pacientes.',
        icon: 'PhoneCall',
        quote: {
          text: 'Perdemos cerca de 30 minutos diários atendendo chamadas para marcar consultas, tempo que poderia ser dedicado aos pacientes',
          author: 'Dr. Miguel Costa',
          business: 'Clínica Médica Costa',
        },
      },
      {
        title: 'Gestão Manual de Agendas',
        description: 'Controlar horários em papel ou planilhas gera erros e conflitos de marcação.',
        icon: 'Clock',
        stats: [
          { label: 'Tempo perdido por semana:', value: '8 horas' },
          { label: 'Conflitos de agenda por mês:', value: '25+' },
        ],
      },
      {
        title: 'Ausências de Pacientes',
        description: 'Faltas sem aviso causam horários perdidos e prejudicam a agenda de outros pacientes que precisam de atendimento.',
        icon: 'Users',
        quote: {
          text: 'Com o sistema de lembretes automáticos, reduziu-se em 88% as faltas às consultas',
          author: 'Dr.ª Catarina Lopes',
          business: 'Clínica Saúde Integral',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'VitaCore: Tecnologia a serviço da saúde',
      description: 'Simplifique a gestão da sua clínica e dedique mais tempo ao que realmente importa: cuidar dos seus pacientes.',
      features: [
        {
          title: 'Marcação Online 24/7',
          description: 'Pacientes podem marcar consultas a qualquer hora, reduzindo chamadas telefónicas.',
        },
        {
          title: 'Histórico Médico Integrado',
          description: 'Acesso rápido ao histórico de consultas e tratamentos de cada paciente.',
        },
        {
          title: 'Lembretes Automáticos',
          description: 'Reduza faltas com lembretes personalizados por email e SMS.',
        },
      ],
    },
    testimonials: {
      title: 'O que os nossos clientes dizem',
      description: 'Médicos que confiam no VitaCore para otimizar seu atendimento.',
    },
    finalCta: {
      title: 'Pronto para otimizar sua clínica?',
      description: 'Junte-se a médicos que já melhoraram seu atendimento com o VitaCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Falar com Especialista',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite médico',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
